import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Box,
  Grid,
  Paper,
  Toolbar,
  makeStyles,
  Typography,
  TextField,
  Chip,
  Button,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TablePagination,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useHistory, useLocation } from 'react-router-dom';
import { debounce } from 'lodash';
import routes from '../../Utils/routes.json';
import KenGrid from '../../global_components/KenGrid';
import KenSelect from '../../global_components/KenSelect';
import KenCheckbox from '../../global_components/KenCheckbox/index';
import KenButton from '../../global_components/KenButton';
import KenLoader from '../../Components/KenLoader/index';
import KenSnackbar from '../../Components/KenSnackbar/index';
import KenDialogBox from '../../global_components/KenDialogBox';
import SearchBox from '../../Components/SearchBox/index';
import KenCard from '../../global_components/KenCard';
import {
  getDataForCourseEnrolment,
  getAcademicFilter,
  getFacultyCourseAssociationSearch,
  postCourseVersionData,
} from '../../Utils/apiServices';
// import { } from 'react-icons/ai';
import './styles.scss';
import { UserDetails } from './data.json';
import FacultyProfile from '../AcademicsPlanner/FacultyProfiles/facultyProfile';
import StudentProfile from '../AcademicsPlanner/StudentsProfile/index';
import { RiCheckFill } from 'react-icons/ri';
import { AiOutlineFilter } from 'react-icons/ai';
import TablePaginationActions from '../../global_components/KenGrid/TablePaginationActions';
import { Country, State, City } from 'country-state-city';
import Tooltip from '@material-ui/core/Tooltip';
const useStyles = makeStyles((theme) => ({
  header: {
    background: '#fff',
    marginTop: '15px',
    width: '100%',
  },
  title: {
    color: theme.palette.KenColors.primary,
    fontWeight: 600,
  },
  selectTabs: {
    padding: '10px',
  },
  facultyInfoSection: {
    background: '#fff',
  },
  accordionMain: {
    background: 'transparent',
  },
  accordionTable: {
    background: '#fff',
  },
  refreshBtn: {
    float: 'right',
    marginTop: '6px',
    height: '34px !important',
    marginBottom: '8px',
    fontSize: '12px',
    fontWeight: 400,
    background: '##272727  !important',
    color: '#fff',
    borderRadius: '5px',
  },
  searchFilter: {
    '&.inputInput': {
      '&:focus': {
        maxWidth: '12ch !important',
      },
    },
  },
  courseList: {
    minHeight: '45px',
    background: '#fff',
    marginTop: '10px',
    width: '100%',
  },
  tableText: {
    position: 'absolute',
    top: '58%',
    right: '52%',
    transform: 'translate(50%, -50%)',
    display: 'flex',
  },
  profile: {
    color: theme.palette.KenColors.primary,
    cursor: 'pointer',
    fontSize: 12,
    textAlign: 'left',
    paddingLeft: '10px',
  },
  searchBar: {
    position: 'relative',
    top: 4,
  },
  searchFilter: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'right',
  },
  applyBtn: {
    justifyContent: 'right',
    marginTop: '13px',
  },
  addusersbtn: {
    float: 'right',
    marginTop: '6px',
    height: '34px !important',
    marginBottom: '8px',
    fontSize: '12px',
    fontWeight: 400,
    background: '##272727  !important',
    color: '#fff',
    borderRadius: '5px',
  },
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  addbtn: {
    marginTop: 'auto',
    height: '34px !important',
    marginLeft: '10px',
  },
}));
const BlueOnGreenTooltip = withStyles({
  tooltip: {
    color: 'lightblue',
    // backgroundColor: "green",
    // padding: 0,
    border: '1px solid #fff',
    borderRadius: '4px',
    background: '#ffffff',
    boxShadow: '-2px 1px 8px 1px #737f8d',
  },
})(Tooltip);

export default function SubjectUsers(props) {
  const {
    variant,
    addReviewedFaculty,
    searchStringVal,
    triggerVal,
    selectedSubject,
    sethandleClick,
    setSelectedUser,
    rowSubject,
    setFacultyAdded,
    checkAvailability
  } = props;
  const classes = useStyles();
  console.log('selectedSubject', selectedSubject);
  const userDetails = localStorage.getItem('userDetails');
  const [data, setData] = React.useState([]);
  const [usersData, setusersData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [selectDepartmentOption, setDepartmentOption] = useState([]);
  const [selectProgramOption, setProgramOption] = useState([]);
  const [selectProgramPlanOption, setProgramPlanOption] = useState([]);
  const [facultyAdded] = useState(false);
  const [selectTermOption, setTermOption] = useState([]);
  const [facultyInfo, setFacultyInfo] = useState({
    department: '',
    program: '',
    programPlan: '',
    term: '',
    type: '',
    country: '',
  });
  const [type, setType] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [term, setTerm] = useState('');
  const [department, setDepartment] = useState('');
  const [program, setProgram] = useState('');
  const [programPlan, setProgramPlan] = useState('');
  const [filterData, setFilterData] = useState([]);
  const [studentInfo, setStudentInfo] = useState({});
  const [profileDialog, setProfileDialog] = useState(false);
  const [selectOptionsCourse, setSelectOptionsCourse] = React.useState([]);
  const [trigger, setTrigger] = useState(false);
  const [clear, setClear] = useState(false);
  const [selectedPreview, setSelectedPreview] = useState({});
  const [pageNO, setpageNO] = useState(0);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [filterChange, setFilterChange] = useState(false);
  //country
  const [selectCountry, setSelectCountry] = useState('');
  const [selectSubject, setSelectSubject] = useState('');
  const [countryDropdownOptions, setcountryDropdownOptions] = useState(
    Country.getAllCountries().map((countries, index) => {
      return {
        label: countries.name,
        value: countries.name,
        // value: countries.isoCode,
      };
    })
  );

  // SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  // Message Modal
  const [messageDialog, setMessageDialog] = useState(false);
  function handleMessageDialog() {
    setMessageDialog((prevState) => !prevState);
    setSelectedUser(usersData);
    setLoading(true);
    let currentSelected = [];
    usersData.map((item) => {
      currentSelected.push({ title: item.facultyName, value: item.facultyId });
    });
    let selectedTerm = [];
    rowSubject.map((item) => {
      item.array.map((item2) => {
        if (item2.courseVersionId === selectedSubject.courseVersionId) {
          selectedTerm.push(item);
        }
      });
    });
    let savedData = selectedTerm[0];
    let termName = savedData.courseName;
    let facultyList = [...selectedSubject?.facultyList, ...currentSelected];
    console.log('facultyList', facultyList);
    const facultyIds = facultyList.map((el) => {
      return `${el.title}-${el.value}`;
    });
    const payload = {
      CourseVersion: {
        termName: termName,
        courseVersionId: selectedSubject.courseVersionId,
        facultyWithId: facultyIds.toString(),
        courseId: selectedSubject.courseRecordId,
        startDate: dateFormatter(selectedSubject.startDate),
        endDate: dateFormatter(selectedSubject.endDate),
      },
    };
    postCourseVersionData(payload)
      .then((res) => {
        setLoading(false);
        setFacultyAdded(!facultyAdded);
        handleSnackbarOpen('success', res.message);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function handleDialogcancel() {
    setMessageDialog((prevState) => !prevState);
    sethandleClick(false);
    setusersData([]);
  }
  const handleClick = () => {
    handleMessageDialog();
  };
  const dateFormatter = (date) => {
    let dArr = date?.split('-');
    return dArr[2] + '/' + dArr[1] + '/' + dArr[0];
  };
  //mui model
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Profile Cell
  const ProfileCell = (row) => {
    const classes = useStyles();
    const { facultyName, type } = row.row.values;
    return (
      <Typography
        className={classes.profile}
        onClick={() => onProfileView(row?.row?.original)}
      >
        {facultyName}
      </Typography>
    );
  };

  //type options
  const searchType = [
    {
      label: 'Faculty',
      value: 'Faculty',
    },
    {
      label: 'Student',
      value: 'Student',
    },
    {
      label: 'All',
      value: 'All',
    },
  ];

  const columns1 = [
    {
      Header: 'Name',
      accessor: 'facultyName',
      Cell: ProfileCell,
      disableGlobalFilter: false,
    },
    {
      Header: 'Email',
      accessor: 'email',
      Cell: ({ value }) => {
        return <a href={`mailto:${value}`}>{value}</a>;
      },
      disableGlobalFilter: false,
    },
    {
      Header: 'Phone',
      accessor: 'phone',
      Cell: ({ value }) => {
        return <a href={`tel:${value}`}>{value}</a>;
      },
      disableGlobalFilter: false,
    },
    {
      Header: 'Subject',
      accessor: 'courseName',
      disableGlobalFilter: false,
    },
    {
      Header: 'Location',
      accessor: 'Location',
      disableGlobalFilter: false,
    },
  ];

  // Columns
  const columns = [
    {
      Header: '',
      accessor: 'checked',
      Cell: ({ value, row }) => {
        return (
          <KenCheckbox
            name={`checkbox`}
            className={classes.checkbox}
            value={value}
            onChange={(event) => selectedCheckBoxItem(event, row, data)}
            color="primary"
          />
        );
      },
      disableGlobalFilter: true,
    },
    {
      Header: 'Name',
      accessor: 'facultyName',
      Cell: ProfileCell,
      disableGlobalFilter: false,
    },
    {
      Header: 'Email',
      accessor: 'email',
      Cell: ({ value }) => {
        return <a href={`mailto:${value}`}>{value}</a>;
      },
      disableGlobalFilter: false,
    },
    {
      Header: 'Phone',
      accessor: 'phone',
      Cell: ({ value }) => {
        return <a href={`tel:${value}`}>{value}</a>;
      },
      disableGlobalFilter: false,
    },
    {
      Header: 'Subject',
      accessor: 'courseDetails',
      Cell: ({ value, row }) => {
        return value != undefined && value != null && value.length > 0 ? (
          <span style={{ cursor: 'pointer' }}>
            {value.map((item) => {
              return (
                <span onClick={(e, item) => renderEventToolTip(item)}>
                  {item?.courseName},{' '}
                </span>
                // <Chip
                //   style={{ marginBottom: 3 }}
                //   label={`${item?.courseName}`}
                // />
              );
            })}
          </span>
        ) : null;
      },
      disableGlobalFilter: false,
    },
    {
      Header: 'Feedback',
      accessor: 'feedback',
      disableGlobalFilter: false,
    },
    {
      Header: 'Location',
      accessor: 'Location',
      disableGlobalFilter: false,
    },
  ];

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };
  const handleSnackbarOpen = (severity, message) => {
    setLoading(false);
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };
  const selectedCheckBoxItem = (event, row, data) => {
    if (event.target.checked) {
      usersData.push(row?.original);
      checkAvailability(row?.original)
      row.original.checked = true;
      return row;
      // setusersData(tempData)
    } else if (!event.target.checked) {
      usersData.splice(row.index, 1);
      row.original.checked = false;
      row.values.checked = false;
      return row;
    }
    // tempData[row.original].checked = event.target.checked;
    // setData(tempData);
    console.log('checked', usersData);
  };
  const handleChangeDepartment = (e) => {
    setFacultyInfo({ ...facultyInfo, department: e.target.value });
    setDepartment(e.target.value);
    console.log(department);
    const ProgramOption = [];
    ProgramOption.push({
      label: '-Select-',
      value: '',
    });
    const dataS = Object.entries(
      filterData.AcdemicProgramsForEachDepartment
    ).filter((item) => {
      if (item[0] == e.target.value) {
        return item;
      } else {
        return false;
      }
    });
    console.log(dataS);
    if (dataS.length > 0) {
      dataS[0][1].map((items) => {
        ProgramOption.push({
          label: items.AcademicProgramName,
          value: items.AcademicProgramId,
        });
      });
    }
    setProgramOption(ProgramOption);
  };
  const handleChangeProgram = (e) => {
    setFacultyInfo({ ...facultyInfo, program: e.target.value });

    setProgram(e.target.value);
    // For Program Plan
    const ProgramPlanOption = [];
    ProgramPlanOption.push({
      label: '-Select-',
      value: '',
    });
    const dataS2 = Object.entries(
      filterData.ProgramPlanForEachAcedemicProgram
    ).filter((item) => {
      if (item[0] == e.target.value) {
        return item;
      }
    });
    if (dataS2.length > 0) {
      dataS2[0][1].map((items) => {
        ProgramPlanOption.push({
          label: items.ProgramPlanName,
          value: items.ProgramPlanId,
        });
      });
    }
    setTermOption([]);
    setProgramPlanOption(ProgramPlanOption);
  };
  const handleChangeProgramPlan = (e) => {
    setTermOption([]);
    setFacultyInfo({ ...facultyInfo, programPlan: e.target.value });

    setProgramPlan(e.target.value);
    const TermOption = [];
    TermOption.push({
      label: '-Select-',
      value: '',
    });
    const dataS = Object.entries(filterData.TermForEachProgramPlan).filter(
      (item) => {
        if (item[0] == e.target.value) {
          return item;
        }
      }
    );
    if (dataS.length > 0) {
      dataS[0][1].map((items) => {
        TermOption.push({
          label: items.TermName,
          value: items.TermId,
        });
      });
    }
    setTermOption(TermOption);
  };
  const handleChangeTerm = (e) => {
    setTerm(e.target.value);
    setFacultyInfo({ ...facultyInfo, term: e.target.value });
  };
  const handleChangeType = (e) => {
    setFacultyInfo({ ...facultyInfo, type: e.target.value });
    let type = e.target.value;
    if (type != 'All') {
      setType(e.target.value);
    }
  };
  const handleChangeCountrySub = (e) => {
    setFacultyInfo({ ...facultyInfo, country: e.target.value });
    setSelectCountry(`${e.target.value}`);
    setFilterChange(!filterChange);
  };
  const handleChangeSubject = (e) => {
    setFacultyInfo({ ...facultyInfo, subjects: e.target.value });
    setSelectSubject(`${e.target.value}`);
    setFilterChange(!filterChange);
  };
  const onProfileView = (data) => {
    // history.push({
    //   pathname: `${routes.facultyProfile}/${data.facultyId}`,
    //   state: { contactId: data.facultyId },
    // });
    window.open(`${routes.facultyProfile}/${data.facultyId}`,'_blank');
  };
  const profileDialogCancel = () => {
    setProfileDialog(false);
  };
  const profileDialogSubmit = () => {
    setProfileDialog(false);
  };

  const clearFilter = () => {
    setClear(!clear);
    setSelectSubject('');
    setSelectCountry('');
    setTrigger(!trigger);
  };
  const handleSubmitFilters = () => {
    setTrigger(!trigger);
    console.log(department);
  };
  // Data
  useEffect(() => {
    setLoading(true);
    let parms = `?facultyName=${searchStringVal}&location=${selectCountry}&courseId=${selectSubject}`;
    getFacultyCourseAssociationSearch(parms)
      .then((res) => {
        let data = [];
        if (res?.data != null) {
          res.data.map((item) => {
            data.push({
              facultyName: item?.facultyName,
              facultyId: item?.facultyId,
              Location: item?.Location,
              email: item?.email,
              phone: item?.phone,
              courseDetails: item?.courseDetails,
            });
          });
          setData(data);
          setLoading(false);
        } else {
          setData([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }, [trigger, page, rowsPerPage, triggerVal, filterChange]);

  useEffect(() => {
    setLoading(true);
    const data = JSON.parse(userDetails);
    const instituteId = data?.Id;
    // const instituteId = '0015j00000rgtHcAAI';
    getDataForCourseEnrolment(instituteId).then((res) => {
      var DepartmentOption = [];
      DepartmentOption.push({
        label: '-select-',
        value: '',
      });
      res?.DepartmentsList.map((item) => {
        DepartmentOption.push({
          label: item.DepartmentName,
          value: item.DepartmentId,
        });
      });
      setDepartmentOption(DepartmentOption);
      setFilterData(res);
      setLoading(false);
    });
  }, []);
  useEffect(() => {
    getAcademicFilter().then((res) => {
      let subjectOptions = [];
      if(Object.entries(res['Courses']).length > 0){
        Object.entries(res['Courses']).map(([item, keyVal]) => {
          subjectOptions.push({
            label: item,
            value: keyVal.id,
          });
        });
      }
      setSelectOptionsCourse(subjectOptions);
      let setVal = selectedSubject?.courseRecordId;
      let e = { target: { value: setVal } };
      handleChangeSubject(e);
    });
  }, []);

  useEffect(() => {
    if (addReviewedFaculty) {
      setMessageDialog((prevState) => !prevState);
    }
  }, [addReviewedFaculty]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Grid xs={12}>
      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
      {loading && <KenLoader />}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Profile
          </Typography>
        }
        open={profileDialog}
        icon={<RiCheckFill />}
        handleClose={() => profileDialogCancel()}
        negativeButtonClick={() => profileDialogCancel()}
        positiveButtonClick={() => profileDialogSubmit()}
        positiveButtonText="Ok"
        maxWidth={'100%'}
        negativeButtonText="Cancel"
        dividers
      >
        <Grid xs={12}>
          {selectedPreview?.recordType == 'Faculty' ? (
            <FacultyProfile state={selectedPreview} />
          ) : (
            <StudentProfile state={selectedPreview} />
          )}
        </Grid>
      </KenDialogBox>
      <Grid container xs={12}>
        <Grid xs={3} className={classes.selectTabs}>
          <KenSelect
            label="Location"
            optionalLabel={false}
            options={countryDropdownOptions}
            value={selectCountry}
            onChange={(e) => handleChangeCountrySub(e)}
            placeholder="Type"
            required
          />
        </Grid>
        <Grid xs={3} className={classes.selectTabs}>
          <KenSelect
            label="Subjects"
            optionalLabel={false}
            options={selectOptionsCourse}
            value={selectSubject}
            onChange={(e) => handleChangeSubject(e)}
            placeholder="Type"
            required
          />
        </Grid>
        <Grid container xs={6} className={classes.applyBtn}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => clearFilter()}
            variant="primary"
            edge="start"
            className={classes.addusersbtn}
            style={{ marginLeft: '10px', marginRight: '10px' }}
          >
            <AiOutlineFilter />
            Clear All
          </IconButton>
        </Grid>
      </Grid>
      <Grid xs={12}>
        <div className="users-table" style={{ width: '100%' }}>
          <KenGrid
            columns={columns}
            data={data}
            pagination={{
              disabled: false,
              rowsPerPageOptions: [5, 10, 25, 50],
              pageSize: 25,
            }}
            toolbarDisabled={true}
            count={data.length}
          />
          {/* <Box style={{ display: 'flex', justifyContent: 'right' }}>
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              colSpan={6}
              count={data.totalNoOfUsers ? data.totalNoOfUsers : data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Box> */}
        </div>
      </Grid>
      <KenDialogBox
        open={messageDialog}
        handleClose={() => handleDialogcancel()}
        negativeButtonClick={() => handleDialogcancel()}
        positiveButtonClick={() => handleMessageDialog()}
        positiveButtonText="submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {usersData.length > 0 ? (
              <KenGrid
                columns={columns1}
                data={usersData}
                toolbarDisabled={true}
              />
            ) : (
              <h1>User is not Selected</h1>
            )}
          </Grid>
        </Grid>
      </KenDialogBox>
    </Grid>
  );
}
function renderEventToolTip(eventInfo) {
  console.log('evebt', eventInfo);
  const toopTiptext = <>tooltip text</>;
  return (
    <BlueOnGreenTooltip title={toopTiptext} placement="bottom">
      <div>
        {eventInfo != undefined &&
          eventInfo.map((item) => {
            return <i className="text-change"> {item?.courseName}</i>;
          })}
      </div>
    </BlueOnGreenTooltip>
  );
}
